import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {
  Nav,
  NavbarBrand,
  NavbarToggler,
  NavItem,
  Badge,
  Collapse,
  Button
} from 'reactstrap';
import { NavLink } from 'react-router-dom';
import HeaderDropdown from './HeaderDropdown';
import MainNav from './MainNav';

class Header extends Component {

  constructor(props) {
    super(props);

    this.state = {
      isOpen: false
    }

    this.mobileMenuToggle = this.mobileMenuToggle.bind(this);
  }

  sidebarToggle(e) {
    e.preventDefault();
    document.body.classList.toggle('sidebar-hidden');
  }

  sidebarMinimize(e) {
    e.preventDefault();
    document.body.classList.toggle('sidebar-minimized');
  }

  mobileSidebarToggle(e) {
    e.preventDefault();
    document.body.classList.toggle('sidebar-mobile-show');
  }

  asideToggle(e) {
    e.preventDefault();
    document.body.classList.toggle('aside-menu-hidden');
  }

  mobileMenuToggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  render() {
    return (
      <div>
        <header className="app-header navbar">
          <NavbarToggler className="d-lg-none" onClick={this.mobileSidebarToggle}>
            <span className="navbar-toggler-icon"></span>
          </NavbarToggler>
          <NavbarToggler className="d-lg-none" onClick={this.mobileMenuToggle}>
            Menu
          </NavbarToggler>
          <NavbarBrand className="d-sm-down-none" href="#"></NavbarBrand>
          <NavbarToggler className="d-md-down-none" onClick={this.sidebarToggle}>
            <span className="navbar-toggler-icon"></span>
          </NavbarToggler>
          <MainNav className="d-md-down-none" state={this.props.state} />
          <Nav className="ml-auto" navbar>
            <NavItem className="px-3">
              <NavLink to="/logout">Logout</NavLink>
            </NavItem>
          </Nav>
        </header>
        <Collapse className="d-lg-none" isOpen={this.state.isOpen} navbar>
          <MainNav className="ml-auto" state={this.props.state} />
        </Collapse>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  state: state
});

export default connect(mapStateToProps)(Header);



// WEBPACK FOOTER //
// ./src/components/Header/Header.js